import { useEffect, useRef, useState } from 'react';

import { useNotificationsCtx } from './context';

export const useUrgentNotificationsCounter = () => {
  const {
    urgentNotifications,
    drawer: { isOpen },
    notificationType
  } = useNotificationsCtx();

  const isUrgentOpen = isOpen && notificationType === 'urgent';

  const urgentNotificationIdsSnapshot = useRef<Set<string>>(
    new Set(urgentNotifications.map(notification => notification.id))
  );

  const [totalUrgentNotifications, setTotalUrgentNotifications] = useState(() => urgentNotifications.length);

  useEffect(() => {
    if (isUrgentOpen && urgentNotifications.length) {
      const newUrgentNotificationIds = new Set(urgentNotifications.map(notification => notification.id));
      // TODO: update typescript to new stable version and remove ts-ignore
      // @ts-ignore
      const diff = newUrgentNotificationIds.difference(urgentNotificationIdsSnapshot.current);
      urgentNotificationIdsSnapshot.current = newUrgentNotificationIds;

      if (diff.size) {
        setTotalUrgentNotifications(prev => prev + diff.size);
      }
    }
  }, [isUrgentOpen, urgentNotifications]);

  return {
    totalUrgentNotifications
  };
};
